import { render, staticRenderFns } from "./ln-form-nested.vue?vue&type=template&id=6b2c5522&"
import script from "./ln-form-nested.vue?vue&type=script&lang=js&"
export * from "./ln-form-nested.vue?vue&type=script&lang=js&"
import style0 from "./ln-form-nested.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LnField: require('/usr/src/app/components/ln-form/ln-field.vue').default})
